/**
 * Weirwood
 * Copyright 2019 Baidu Inc. All rights reserved.
 *
 * @file 获取全局对象
 * @author zengxiaohui(zengxiaohui@baidu.com)
 */

/**
 * 没有找到 global、self、window 等全局对象后，用一个空对象模拟全局对象
 */
const fallbackGlobalObject = {};

/**
 * 获取全局对象，检测顺序为：window || global || self || {}
 */
export function getGlobal(): Window | NodeJS.Global | {} {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }

    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    return fallbackGlobalObject;
}
